import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/partners_click_here.jpg'


const _hoisted_1 = {
  id: "partners-component",
  class: "text-white mt-4"
}
const _hoisted_2 = { class: "row ms-0" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "row red-color text-center fs-5" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "row ms-0" }
const _hoisted_7 = {
  class: "col-11 offset-1 border text-center",
  id: "partners-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.title), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("img", {
          alt: "Logos",
          class: "w-50 mb-4 mt-3 border",
          src: _imports_0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/partners')))
        })
      ])
    ])
  ]))
}